import { Action } from '@ngrx/store';
import { Vehicle } from '@cemex-core/cmx-api/models/vehicles/model/vehicle';

export const RESET = '[Vehicles] Reset';
export const LOAD_VEHICLES = '[Vehicles] Load Vehicles';
export const LOAD_VEHICLES_COMPLETE = '[Vehicles] Load Vehicles Complete';

export class LoadVehiclesAction implements Action {
  readonly type = LOAD_VEHICLES;

  constructor(public payload: number) {}
}

export class LoadVehiclesCompleteAction implements Action {
  readonly type = LOAD_VEHICLES_COMPLETE;

  constructor(public payload: Vehicle[]) {}
}

export class VehiclesResetAction implements Action {
  readonly type = RESET;

  constructor() {}
}

export type VehiclesActions = LoadVehiclesAction | LoadVehiclesCompleteAction | VehiclesResetAction;
